module.exports = __webpack_public_path__ + "img/Ninja Gaming_2.jpg";